export default {
  state: {
    menu: '',
    userId: '',
    userName: '',
    name: '',
    email: '',
    company: '',
    group: []
  },
  mutations: {
    'SIGNIN' (state, user) {
      Object.assign(state, user)
      // GrowingIO
      window._vds.push(['setCS1', 'userId', user.userId])
      window._vds.push(['setCS2', 'name', user.name])
      window._vds.push(['setCS3', 'nickName', user.nickName])
      window._vds.push(['setCS4', 'email', user.email])
      window._vds.push(['setCS5', 'mobile', user.mobile])
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js